// Libraries
import React, {forwardRef} from 'react'
import classnames from 'classnames'

// Types
import {StandardFunctionProps, InfluxColors} from '../../../../Types'

// Styles
import '../../InfluxLogo.scss'

export interface CloudProps extends StandardFunctionProps {
  /** Coloration of the SVG image */
  fill?: InfluxColors | string
}

export type CloudRef = SVGSVGElement

export const Cloud = forwardRef<CloudRef, CloudProps>(
  (
    {
      className = '',
      id = 'svg--influxdata',
      fill = InfluxColors.White,
      testID = 'svg--influxdata',
    },
    ref
  ) => {
    const logoClass = classnames('cf-logo cf-logo-auxiliary', {
      [`${className}`]: className,
    })

    const logoStyle = {fill, marginTop: '4.5px', marginLeft: '14px'}

    return (
      <svg
        version="1.1"
        id={id}
        data-testid={testID}
        style={logoStyle}
        x="0px"
        y="0px"
        viewBox="0 0 258 84"
        width="96"
        height="31"
        ref={ref}
      >
        <path
          className={logoClass}
          d="M27.601 83.308c-5.566 0-10.395-1.073-14.486-3.22-4.091-2.145-7.276-5.163-9.556-9.053C1.346 67.08.239 62.451.239 57.153s1.14-9.959 3.42-13.982c2.281-4.024 5.466-7.142 9.557-9.355 4.091-2.28 8.852-3.42 14.284-3.42 2.616 0 5.231.335 7.847 1.005 2.615.67 4.962 1.576 7.041 2.716l-1.207 7.344c-1.878-1.006-4.091-1.811-6.639-2.415-2.549-.67-4.896-1.005-7.042-1.005-5.566 0-10.059 1.71-13.479 5.13-3.353 3.353-5.03 7.88-5.03 13.58 0 5.902 1.71 10.529 5.13 13.882 3.42 3.353 8.081 5.03 13.983 5.03 2.213 0 4.459-.269 6.74-.805 2.347-.537 4.862-1.375 7.544-2.515l1.006 7.142c-2.146 1.207-4.627 2.146-7.444 2.817a35.11 35.11 0 0 1-8.349 1.006ZM57.986 82V.519h8.551V82h-8.551Zm49.457 1.61c-5.029 0-9.523-1.174-13.479-3.521-3.957-2.347-7.109-5.533-9.456-9.557-2.28-4.023-3.42-8.584-3.42-13.68 0-5.03 1.173-9.557 3.52-13.58 2.348-4.024 5.5-7.21 9.456-9.557 4.024-2.414 8.484-3.621 13.379-3.621 5.03 0 9.523 1.173 13.48 3.52 4.024 2.348 7.175 5.533 9.456 9.557 2.28 4.023 3.42 8.584 3.42 13.68 0 4.963-1.174 9.49-3.521 13.58-2.347 4.025-5.533 7.243-9.556 9.658-3.957 2.347-8.383 3.52-13.279 3.52Zm0-7.646c3.487 0 6.539-.804 9.154-2.414 2.616-1.61 4.661-3.856 6.136-6.74 1.543-2.883 2.314-6.203 2.314-9.959 0-3.755-.771-7.075-2.314-9.958-1.475-2.884-3.52-5.13-6.136-6.74-2.615-1.61-5.667-2.414-9.154-2.414-3.42 0-6.471.805-9.154 2.414-2.615 1.61-4.694 3.856-6.237 6.74-1.475 2.883-2.213 6.203-2.213 9.959 0 3.755.738 7.075 2.213 9.958 1.543 2.884 3.622 5.13 6.237 6.74 2.683 1.61 5.734 2.414 9.154 2.414Zm58.323 7.645c-5.7 0-10.092-1.71-13.177-5.13-3.018-3.487-4.527-8.45-4.527-14.888V31.703h8.55v29.474c0 5.298.939 9.12 2.817 11.468 1.878 2.28 4.963 3.42 9.255 3.42 4.359 0 7.779-1.475 10.26-4.426 2.549-3.018 3.823-7.075 3.823-12.172V31.703h8.55V82h-8.047l-.201-8.651c-1.342 3.286-3.521 5.834-6.539 7.645-3.018 1.744-6.606 2.615-10.764 2.615Zm64.322 0c-4.627 0-8.785-1.14-12.473-3.42-3.622-2.28-6.472-5.432-8.551-9.455-2.079-4.091-3.118-8.719-3.118-13.882 0-4.963 1.106-9.456 3.319-13.48 2.28-4.09 5.332-7.31 9.154-9.657 3.823-2.414 8.048-3.621 12.675-3.621 3.823 0 7.31.938 10.462 2.816 3.219 1.878 5.801 4.527 7.746 7.947V.52h8.55V82h-8.349l-.201-9.154c-2.012 3.42-4.661 6.07-7.947 7.947-3.286 1.878-7.042 2.816-11.267 2.816Zm2.213-7.645c3.488 0 6.539-.804 9.154-2.414 2.616-1.61 4.661-3.856 6.137-6.74 1.542-2.883 2.313-6.203 2.313-9.959 0-3.755-.771-7.075-2.313-9.958-1.476-2.884-3.521-5.13-6.137-6.74-2.615-1.61-5.666-2.414-9.154-2.414-3.42 0-6.471.805-9.154 2.414-2.615 1.61-4.694 3.856-6.237 6.74-1.475 2.883-2.213 6.203-2.213 9.959 0 3.755.738 7.075 2.213 9.958 1.543 2.884 3.622 5.13 6.237 6.74 2.683 1.61 5.734 2.414 9.154 2.414Z"
        />
      </svg>
    )
  }
)

Cloud.displayName = 'Cloud'
